import React, { useState } from 'react';
import { Layout, Row, Col, Form, Input, Button, message } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import * as authService from './authService';

const { Content } = Layout;

const VerifyEmail = () => {
  const [loading, setLoading] = useState(false);

  // Get email from URL params
  const params = new URLSearchParams(window.location.search);
  const defaultEmail = params.get('email') || '';

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.confirmEmail(values.email, values.code);
      message.success('이메일 인증이 완료되었습니다. 로그인해주세요.');
      window.location.href = '/login';
    } catch (err) {
      console.error('Verify error:', err);
      const msg = err.response?.data?.message || err.message || '인증에 실패했습니다';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const resendCode = async () => {
    const email = document.querySelector('input[id="verify_email"]')?.value || defaultEmail;
    if (!email) {
      message.warning('이메일을 입력해주세요');
      return;
    }
    try {
      await authService.resendCode(email);
      message.success('인증 코드가 재전송되었습니다');
    } catch (err) {
      const msg = err.response?.data?.message || '코드 재전송에 실패했습니다';
      message.error(msg);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', padding: '25px' }}>
      <Content>
        <Row>
          <Col span={8} offset={8}>
            <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>
              이메일 인증
            </h2>
            <p style={{ textAlign: 'center', marginBottom: '30px' }}>
              가입 시 입력한 이메일로 전송된 인증 코드를 입력해주세요.
            </p>
            <Form
              name="verify_email"
              onFinish={onFinish}
              initialValues={{ email: defaultEmail }}
            >
              <Form.Item
                name="email"
                rules={[{ required: true, message: '이메일을 입력하세요' }]}
              >
                <Input
                  id="verify_email"
                  prefix={<MailOutlined />}
                  placeholder="이메일"
                />
              </Form.Item>
              <Form.Item
                name="code"
                rules={[{ required: true, message: '인증 코드를 입력하세요' }]}
              >
                <Input
                  prefix={<LockOutlined />}
                  placeholder="인증 코드 (6자리)"
                  maxLength={6}
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  인증 확인
                </Button>
              </Form.Item>
              <Form.Item>
                <Button type="link" onClick={resendCode} block>
                  인증 코드 재전송
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default VerifyEmail;
